// @ts-expect-error - geeft error

import tailwindConfig from '@tailwind-config';
import resolveConfig from 'tailwindcss/resolveConfig';
import { computed, type ComputedRef } from 'vue';
import { type MaybeComputedElementRef, useElementSize } from '@vueuse/core';

type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl';
type Type = keyof typeof operators;
interface Breakpoint {
  size: Size;
  type: Type;
}

const operators = {
  max: (containerWidth: number, targetWidth: number) => containerWidth < targetWidth,
  min: (containerWidth: number, targetWidth: number) => containerWidth >= targetWidth,
};
const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
const { theme } = resolveConfig(tailwindConfig);

type UseBreakpointsForElementReturn<T> = T extends Breakpoint[]
  ? { [K in T[number] as `${K['type']}${K['size']}`]: ComputedRef<boolean> }
  : T extends Breakpoint
    ? { [K in `${Extract<T['type'], string>}${Extract<T['size'], string>}`]: ComputedRef<boolean> }
    : never;

export function useBreakpointsForElement<T extends Breakpoint | Breakpoint[]>(
  containerElement: MaybeComputedElementRef,
  oneOrMultipleBreakpoints: T,
): UseBreakpointsForElementReturn<T> {
  const { width } = useElementSize(containerElement);
  const breakpoints: Breakpoint[] = Array.isArray(oneOrMultipleBreakpoints)
    ? oneOrMultipleBreakpoints
    : [oneOrMultipleBreakpoints];

  return Object.fromEntries(
    breakpoints.map(({ size, type }) => [
      `${type}${size}`,
      computed(() =>
        operators[type](width.value, Number.parseInt(theme.containers[size], 10) * remInPx),
      ),
    ]),
  ) as UseBreakpointsForElementReturn<T>;
}
